import { testStatus as testStatusConst } from '../commons/constants';
import type {
    Options,
    LoginModeOptions,
    TunnelOptions,
    RunnerOptions,
    AgentModeOptions,
    InstallLazyDepsOptions,
} from '../runOptions';

export function getUniqBrowsers(options: RunnerOptions, testList: { runConfig?: { browserValue: string } }[]) {
    if (options.browserstack?.browserName || options.saucelabs?.browserName) {
        return [options.browser?.toLowerCase()];
    }
    if ((options.testConfigNames?.length || options.testConfigIds?.length || options.testPlan.length || options.testPlanIds.length) || !options.browser) {
        return [...new Set(testList.map(t => t.runConfig?.browserValue))];
    }

    return [options.browser?.toLowerCase()];
}

export const hasTestPlanFlag = (options: Partial<Pick<RunnerOptions, 'testPlan' | 'testPlanIds'>>) => Boolean(options.testPlan?.length || options.testPlanIds?.length);

export const isRemoteRun = (options: RunnerOptions) => Boolean(options.resultId && options.source === 'remote-run');

export const isQuarantineAndNotRemoteRun = (test: { testStatus?: string }, options: RunnerOptions) =>
    test.testStatus === testStatusConst.QUARANTINE &&
    !isRemoteRun(options) &&
    !options.runQuarantinedTests;

export function getArgsOnRemoteRunFailure() {
    const { argv: args } = process;
    if (!args.includes('--remoteRunId')) {
        return undefined;
    }
    return {
        remoteRunId: args[args.indexOf('--remoteRunId') + 1],
        projectId: args[args.indexOf('--project') + 1],
        token: args[args.indexOf('--token') + 1],
    };
}

export const isLoginMode = (options: Options): options is LoginModeOptions => Boolean((options as any).loginMode);

export const isTunnelOnlyMode = (options: Options): options is TunnelOptions => Boolean((options as any).tunnelOnlyMode);

export const isCreatePrefetchedDataMode = (options: Options): options is RunnerOptions & { createPrefechedData: true } => Boolean((options as any).createPrefechedData);

export const isInstallLazyDepsMode = (options: Options): options is InstallLazyDepsOptions => Boolean((options as any).installLazyDepsMode);

export const isAgentMode = (options: Options): options is AgentModeOptions => Boolean((options as any).agentMode);

export const replaceArgsWithNoDashes = (args: string[], nonDashFlags: Set<string>) => {
    args.forEach((arg, i) => {
        if (nonDashFlags.has(arg)) {
            args[i] = `--${arg}`;
        }
    });
};

export const spreadObjectToArgs = (obj: Record<string, any>): string[] => {
    const args: string[] = [];
    Object.entries(obj).forEach(([key, value]) => {
        if (value) {
            args.push(`--${key}`, value);
        }
    });
    return args;
};
